import * as React from 'react';
import classnames from 'classnames';

import Spinner from 'components/spinner/Spinner';

import { __t, applyTranslations } from 'utils/language';

import './sov-analysis-results-section.scss';

applyTranslations(require('modules/insights/sov/shared/sov-shared.i18n.json'));

type Props = {
  header: any,
  subline?: string,
  children?: any,
  isLoading: boolean,
  isEmpty: boolean,
  withStyles: boolean,
  noResultsLabel: string
};

const SHARED_MSG_KEY = 'sov_shared';

class SOVAnalysisResultsSection extends React.Component<Props> {
  static defaultProps = {
    noResultsLabel: __t(`${SHARED_MSG_KEY}.messages.no_results`),
    withStyles: true
  };

  getContent(): React.ReactNode {
    const { children, isLoading, isEmpty, noResultsLabel, withStyles } = this.props;

    if (isLoading) {
      return (
        <div className="sov-analysis-results-section__spinner">
          <Spinner
            position="inline"
            size="small"
            color="light"
          />
        </div>
      );
    }

    const emptyClasses = classnames('sov-analysis-results-section__empty-container', {
      'sov-analysis-results-section__empty-container--with-styles': withStyles
    });

    const resultsClasses = classnames('sov-analysis-results-section__results-container', {
      'sov-analysis-results-section__results-container--with-styles': withStyles
    });

    if (isEmpty) {
      return (
        <div className={emptyClasses}>
          {noResultsLabel}
        </div>
      );
    }

    return (
      <div className={resultsClasses}>
        {children}
      </div>
    );
  }

  render(): React.ReactNode {
    const { header, subline } = this.props;

    return (
      <div className="sov-analysis-results-section">
        <div className="sov-analysis-results-section__header">
          {header}
        </div>
        <div className="sov-analysis-results-section__subline">
          {subline}
        </div>
        {
          this.getContent()
        }
      </div>
    );
  }
}

export default SOVAnalysisResultsSection;
